import React, { useState } from "react"
import { generatePath, Link } from "react-router-dom"
import { observer } from "mobx-react"
import { Button } from "antd"
import Table, { ColumnsType } from "antd/es/table"
import { DeleteOutlined } from "@ant-design/icons"

import { DeleteConfirm } from "@src/app/components/DeleteConfirm"
import { notify } from "@src/app/components/notify"
import { paths } from "@src/app/paths"
import { BankDetailsCollection } from "@src/pages/settingsBankDetails/classes/BankDetailsCollection"
import { catchErrors } from "@src/shared/api"
import { BankAccountResponse } from "@src/shared/api/generated"
import { WithCollection } from "@src/shared/classes/Collection/types"

type Props = WithCollection<BankDetailsCollection>
export const BanksDetailTable = observer(({ collection }: Props) => {
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false)

  const [chosenId, setChosenId] = useState("")

  const columns: ColumnsType<BankAccountResponse> = [
    {
      align: "center",
      dataIndex: "name",
      render: (_, { id, name }) => {
        return (
          id && (
            <Link
              id="GENERATED_ID_BANKSDETAILTABLE_LINK_VOID_1"
              to={generatePath(paths.bankDetailSlug, { id })}
            >
              {name}
            </Link>
          )
        )
      },
      title: "Name",
    },
    {
      align: "center",
      dataIndex: "currency",
      title: "Currency",
    },
    {
      align: "center",
      render: (_, { id }) => (
        <Button
          icon={<DeleteOutlined />}
          loading={collection.isLoading}
          onClick={() => onButtonClick(id as string)}
          type="text"
        />
      ),
      title: "Action",
    },
  ]

  const onButtonClick = (id: string) => {
    setChosenId(id)

    setOpenDeleteConfirm(true)
  }

  const onDeleteConfirm = () => {
    collection
      .delete(chosenId)
      .then(() => notify.success("Bank account has been deleted"))
      .catch(catchErrors)
      .finally(() => {
        setOpenDeleteConfirm(false)

        setChosenId("")
      })
  }

  const onDeleteCancel = () => {
    setOpenDeleteConfirm(false)

    setChosenId("")
  }

  return (
    <>
      <Table
        columns={columns}
        dataSource={collection.items}
        loading={collection.isLoading}
        pagination={collection.pagination}
      />
      <DeleteConfirm
        cancelText="Cancel"
        isLoading={collection.isLoading}
        okText="Delete Address"
        onCancel={onDeleteCancel}
        onOk={onDeleteConfirm}
        open={openDeleteConfirm}
        text="This action cannot be undone"
        title="Are you sure you want to delete this account?"
      />
    </>
  )
})
